import Vue from 'vue'
import Dashboard from './components/Dashboard'
import Checkout from './components/Checkout'
import NonEmptyCart from './components/NonEmptyCart'
import CartGallery from './components/CartGallery'
import Rating from './components/Rating'
import Offers from './components/Offers'
import ProductDetails from './components/ProductDetails'
import ProductLinks from './components/ProductLinks'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    routes:[
        {
            path: '/:handle',
            name:'Home',
            component:Dashboard
        },
        {
            path:'/:handle/checkout',
            name:'checkout',
            component:Checkout
        },
        {
            path:'/:handle/gallery',
            name:'gallery',
            component:CartGallery
        },
        {
            path:'/:handle/cart',
            name:'cart',
            component:NonEmptyCart
        },
        {
            path:'/:handle/offers',
            name:'offers',
            component:Offers
        },
        {
            path:'/:handle/productdetails',
            name:'productdetails',
            component:ProductDetails
        },
        {
            path:'/:handle/productLink',
            name:'productLink',
            component:ProductLinks
        },
        {
            path:'/:handle/ratings',
            name:'ratings',
            component:Rating
        }
    ]
})